/**
 * 提供與後台連結的 api 接口
 */
import axios from "axios/index";
import qs from 'qs';

//TODO: Consider setting path config
export default {

    /**
     * Get Main and sub category
     * @returns {AxiosPromise<any>}
     */
    getMainCate() {
        /*
       return axios.get('/api/main_category/get_main_cate_by_website/', {
           params: {
               subject: window.urlData.subjectCompo
           }});
           */
        return axios.get(`/api/main_category/get_main_cate_by_website?subject=${window.urlData.subjectCompo}`);
        //return axios.get('/js/testdata/maincate_frontend_example.json');
    },
    /**
     * Get the banner in home page
     * @returns {AxiosPromise<any>}
     */
    getBanner() {
        return axios.get(`/api/home/get_banner?subject=${window.urlData.subjectCompo}`);
        //return axios.get(`js/testdata/banner.json`);
    },

    /**
     * Get sub category listing
     * @param subcateId
     * @param status
     *
     * @returns {AxiosPromise<any>}
     */
    getSubCateListById(subcateId, status = "Final") {


        return axios.post('/api/subcate/nswfrontend_get_by_id', {
            sub_cate_id: subcateId,
            status: status
        });


        //return axios.get('/js/testdata/resource_simple.json')
        //return axios.get('/js/testdata/reso xurce_group.json');
    },
    async getSubcateByIdFaster(subcateId, status = "Final") {
        try {
            const data = (await axios.post('/api/subcate/nswfrontend_get_overview_by_id', {
                sub_cate_id: subcateId,
                status: status
            })).data
            const arr = []
            for (const item of data.resources) {
                arr.push(axios.post('/api/subcate/nswfrontend_get_detail', {
                    subcate_id: subcateId,
                    uri_list: item.resource ? item.resource.map(el => el.uri) : [],
                    status: status
                }))
            }
            return await Promise.all(arr).then(res2 => {
                res2.forEach((el, index) => {
                    data.resources[index].resource = el.data.resource
                })
                let num = 1
                data.resources.forEach((el1, index1) => {
                    if (el1.resource) {
                        el1.resource.forEach((el2, index2) => {
                            data.resources[index1].resource[index2].row = num
                            num++
                        })
                    }
                })
                return {
                    data: data
                }
            })
        }
        catch (err) {
            console.log(err)
            throw err
        }
    },
    getSubcateById(subcateId, status = "Final") {
        return axios.post('/api/subcate/get_lom_by_id', {
            subcate_id: subcateId
        });
    },

    /**
     * Get the data for My Download
     *
     * @return {Promise<any>}
     */
    getDownloadData(skip = 0, limit = 5) {
        return new Promise((resolve, reject) => {
            axios.post('/api/my_download/get_by_id', {
                "website": `${window.urlData.subjectCompo}`,
                "skip": skip,
                "limit": limit
            }
            ).then(response => {
                //TODO: handle more practical cases if necessary. Now just simply check status 200
                if (response.status === 200) {
                    resolve(response);
                } else {
                    reject(response)
                }
            })
        });
    },
    /**
     * from MyDownload.vue
     *
     * remove resource by array key
     *
     * @param key
     * @returns {AxiosPromise<any>}
     */
    removeResource(key) {
        return axios.post('/api/my_download/remove_resource', {
            "resource_key": key,
            "website": `${window.urlData.subjectCompo}`
        });
    },
    /**
     * from MyDownload.vue
     *
     * remove all selected resources
     *
     * @returns {AxiosPromise<any>}
     */
    removeAllResource() {
        return axios.post('/api/my_download/remove_all_resource', {
            "website": `${window.urlData.subjectCompo}`
        });
    },

    /**
     * from MyDownload.vue
     *
     * save and pack download zip file
     *
     * @returns {AxiosPromise<any>}
     */
    saveMyDownloadRecord() {
        return axios.post('/api/my_download/save_my_download_record', {
            "website": `${window.urlData.subjectCompo}`
        });
    },
    /**
     *
     * @param obj_resource
     * @return {AxiosPromise<any>}
     */
    saveResourceToMyDownload(obj_resource) {
        return axios.post('/api/my_download/save', {
            "resource_list": obj_resource,
            "return_list": true,
            "website": `${window.urlData.subjectCompo}`
        }
        );
    },
    /**
     * get News Table
     * @return {AxiosPromise<any>}
     */
    getHkepNews() {
        return axios.get(`/api/news/get_news?subject=${window.urlData.subjectCompo}`);
    },

    /**
     * 取得該網站的module html
     * @return {AxiosPromise<any>}
     */
    getModule() {
        return axios.get(`/api/module/get_all_frontend?subject=${window.urlData.subjectCompo}`);
    },
    /**
     * frontend 搜尋api
     *
     * @param keywords string
     * @param skip int
     * @param limit int
     * @return {AxiosPromise<any>}
     */
    searchFrontend(keywords, skip, limit) {
        return axios.post(
            `/api/search/frontend`,
            {
                "subject": `${window.urlData.subjectCompo}`,
                "keywords": keywords,
                "skip": skip,
                "limit": limit,
                "access_token": access_token
            }
        );
    },
    getResourcePageFrontendById(id) {
        return axios.post('/api/resource_page/get_frontend_by_id', {
            "id": id,
            "website": `${window.urlData.subjectCompo}`
        }
        );
    },
    userLogin(username, password) {
        return axios.post('/api/user/login', {
            'username': username,
            'password': password
        });
    },
    /**
     *
     */
    userLogout() {
        return axios.get("/api/user/logout");
    },
    /**
     *
     */
    getContactUsById() {
        return axios.post('/api/contact_us/get_by_id', {
            "id": `${window.urlData.subjectCompo}`
        });
    },
    checkLoginStatus(uri = "") {
        return axios.post(
            "/api/user/check_login_status", {
            "request_uri": uri
        }
        );
    },
    checkDownloadStatus(id) {
        return axios.get(`/api/check_download/${id}`);
    },
    getMpmsSystemMsg(url) {
        return axios.post(
            url,
            qs.stringify({
                "access_token": access_token,
                "client_id": client_id
            }),
            {
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded'
                }
            }
        );
    },
    getWebsitePopup() {
        return axios.post('/api/popup/get_frontend_by_website_id',
            {
                "id": `${window.urlData.subjectCompo}`
            }
        );
    },
    getSearchResultEntryFrontend() {
        return axios.post('/api/search_result_entry/get_by_website_id_frontend', {
            "website_id": window.urlData.subjectCompo
        })
    }
}



// WEBPACK FOOTER //
// ./resources/assets/js/api.js